import { render, staticRenderFns } from "./message-abstract-text.vue?vue&type=template&id=d0fc2cc6&scoped=true"
import script from "./message-abstract-text.vue?vue&type=script&lang=ts"
export * from "./message-abstract-text.vue?vue&type=script&lang=ts"
import style0 from "./message-abstract-text.vue?vue&type=style&index=0&id=d0fc2cc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0fc2cc6",
  null
  
)

export default component.exports